export function LoadingView() {
  return (
    <div style={{margin: 'auto'}}>
      <div className='spinner'/>
      <p style={{marginTop: 80}}>Getting your tasks...</p>
    </div>
  );
}
